<script setup lang="ts">
import KpSelectField from '@/components/KpSelectField.vue';
import { NutzungsartCollection } from '@/models/Nutzungsart';
import { onMounted, type Ref } from 'vue';
import { useI18n } from 'vue-i18n';

const value: Ref<any> = defineModel();

withDefaults(
    defineProps<{
        label?: string;
    }>(),
    { label: () => useI18n().t('nutzungsart') },
);

const coll = new NutzungsartCollection();

onMounted(() => {
    coll.query();
});
</script>
<template>
    <KpSelectField
        :label="label"
        v-model="value"
        :options="coll.getModels()"
        option-label="bezeichnung"
        option-value="id"
    ></KpSelectField>
</template>
